import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.products;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const isLoadingImportSelector = createSelector(
    selectFeature, 
    (state) => state.isLoadingImport
);

export const productsSelector = createSelector(
    selectFeature, 
    (state) => state.products
);

export const productsTotalSelector = createSelector(
    selectFeature, 
    (state) => state.total
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);